import { useState, useEffect } from "react";

const LS_KEY = "kaizu_fontSize";
const DEFAULT = 16;
const MIN = 13;
const MAX = 22;

export function useFontSize() {
  const [fontSize, setFontSize] = useState(() => {
    const saved = localStorage.getItem(LS_KEY);
    return saved ? parseInt(saved, 10) : DEFAULT;
  });

  useEffect(() => {
    localStorage.setItem(LS_KEY, String(fontSize));
    document.documentElement.style.setProperty("--kaizu-font-size", `${fontSize}px`);
  }, [fontSize]);

  // Set on initial load
  useEffect(() => {
    document.documentElement.style.setProperty("--kaizu-font-size", `${fontSize}px`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const increase = () => setFontSize((s) => Math.min(s + 1, MAX));
  const decrease = () => setFontSize((s) => Math.max(s - 1, MIN));
  const reset = () => setFontSize(DEFAULT);

  return { fontSize, increase, decrease, reset, isDefault: fontSize === DEFAULT };
}
